import { SuccessOrError } from '../../types/SharedOrder.types';

export const ERROR_VALIDATION_STATUS = 'error' as SuccessOrError;
export const SUCCESS_VALIDATION_STATUS = 'success' as SuccessOrError;
